import { useRecoilState } from "recoil";
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent
} from "@mui/material";
import { prefixState } from "features/file-browser/state/fileAtoms";
import { CustomTypography } from "shared/ui/CustomTypography";

export const PrefixSelector: React.FC = () => {
  const [prefix, setPrefix] = useRecoilState(prefixState);

  const handleChange = (event: SelectChangeEvent<string>) => {
    setPrefix(event.target.value);
  };

  return (
    <Box
      component='div'
      ml={1}
      sx={{
        display: 'flex',
        alignItems: 'center',
        paddingTop: 1,
        gap: 1
      }}
    >
      <CustomTypography>Prefix:</CustomTypography>
      <FormControl
        size="small"
        sx={{
          width: '50%',
          backgroundColor: '#404040',
          borderRadius: 1
        }}
      >
        <Select
          labelId="dmorphing-direction-label"
          value={prefix}
          onChange={handleChange}
          size="small"
          sx={{
            color: '#f0f0f0',  // Set input text color
            fontSize: '12px',
            '.MuiSvgIcon-root': { color: '#f0f0f0' },  // Optional: Set dropdown arrow color
          }}
        >
          <MenuItem value="model">Base Model</MenuItem>
          <MenuItem value="cocoon">Cocoon</MenuItem>
          <MenuItem value="tire">Tire</MenuItem>
          <MenuItem value="wheelhouse">Wheelhouse</MenuItem>
          <MenuItem value="morphed">Morphed</MenuItem>
        </Select>
      </FormControl>
    </Box >
  );
}
